module.exports = __webpack_public_path__ + "static/Sound_Portrait-c3b19e78f2ae907db9a23ebd7206229a.png";